<template>
  <div class="view-projects">
    <div class="view-projects__content">
      <div class="view-projects-title-top hide-to-reveal">
        {{ titleTop }}
      </div>
      <h1 class="view-projects__title hide-to-reveal">{{ title }}</h1>

      <!-- filters -->
      <div class="taxonomy-links__container hide-to-reveal reveal--delay-medium">
        <div class="taxonomy-links">
          <template v-for="filter in filters.categories">
            <div
              v-if="countEntries(filter.id) > 0"
              class="taxonomy-link"
              :class="{
                'taxonomy-link--active': activeCategoryId === filter.id,
              }"
              :key="filter.id"
              @click="handleCategoryClick(filter.id)">
              {{ filter.name }}
              <span>{{ countEntries(filter.id) }}</span>
            </div>
          </template>
        </div>
      </div>

      <!-- content -->
      <div class="view-projects__projects">
        <div class="view-projects__rows row hide-to-reveal">
          <div
            class="view-projects__row column"
            v-for="project in filteredProjects"
            :key="project.id">
            <a :href="project.url" class="project-teaser" data-observe>
              <div class="project-teaser__image">
                <div class="project-teaser__background-image">
                  <responsive-image :images="project.images" />
                </div>
                <div class="project-teaser__logo">
                  <responsive-image :images="project.logo" />
                </div>
              </div>
              <div class="project-teaser__description">
                <div v-if="project.client" class="project-teaser__client h5">
                  {{ project.client }}
                </div>
                <div class="project-teaser__title h3">
                  {{ project.title }}
                </div>
                <div
                  :class="[
                    'project-teaser__categories',
                    'label__categories',
                    'label__categories--dark',
                  ]">
                  <div
                    v-for="(category, idx) in project.categories"
                    class="label__category"
                    :key="idx">
                    {{ category.name }}
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @todo this is the same code as Blog.vue
// 3rd.
import 'url-search-params-polyfill';

// Utils.
import initObserver from '../js/utils/reveal';
import scrollFader from '../js/elements/horizontalSwipeOverlay';

// Components.
import ResponsiveImage from './ResponsiveImage';

export default {
  name: 'projects',
  components: {
    ResponsiveImage,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    titleTop: {
      type: String,
      required: true,
    },
    filters: {
      type: Object,
      required: true,
    },
    projects: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      activeCategoryId: 0,
      defaultCategoryId: 0,
      urlParams: new URLSearchParams(window.location.search),
    };
  },
  computed: {
    filteredProjects() {
      return Object.values(this.projects).filter((proj) => {
        // filter projects that have at least one category
        if (this.activeCategoryId === this.defaultCategoryId) {
          return proj.categories;
        }

        // filter projects that match category
        if (this.activeCategoryId && proj.categories) {
          return proj.categories.some(
            (cat) => cat.id === this.activeCategoryId,
          );
        }

        return false;
      });
    },
  },
  watch: {
    filteredProjects(val, oldVal) {
      // update URL params with active filter selection
      // but only after initial value has been computed
      if (oldVal.length) {
        this.setUrlParams();
      }
    },
  },
  mounted() {
    this.defaultCategoryId = this.filters.categories[0].id;

    // check URL for params
    this.urlParams.toString()
      ? this.parseUrlParams()
      : (this.activeCategoryId = this.defaultCategoryId);

    // Init reveal util.
    this.$nextTick(initObserver);

    // Init categories scroll (for mobile).
    scrollFader();
  },
  methods: {
    countEntries(id) {
      return Object.values(this.projects).reduce((acc, curr) => {
        if (
          (curr.categories && curr.categories.some((cat) => cat.id === id)) ||
          (id === 0 && curr.categories)
        ) {
          const increase = (acc += 1);
          return increase;
        }

        return acc;
      }, 0);
    },
    handleCategoryClick(id) {
      this.activeCategoryId = id;
      this.$nextTick(initObserver);
    },
    setUrlParams() {
      this.urlParams = new URLSearchParams({
        category: this.getCategoryMachineName(this.activeCategoryId),
      });
      // Update URL with new URL params.
      history.replaceState(
        null,
        '',
        this.urlParams.toString()
          ? `?${this.urlParams.toString()}`
          : window.location.pathname,
      );
    },
    parseUrlParams() {
      this.urlParams.forEach((param) => {
        this.activeCategoryId = this.getCategoryIdByName(param);
      });
    },
    getCategoryMachineName(id) {
      const category = Object.values(this.filters.categories).find(
        (cat) => cat.id === id,
      );
      return category ? category.machine_name : null;
    },
    getCategoryIdByName(machineName) {
      const category = Object.values(this.filters.categories).find(
        (cat) => cat.machine_name === machineName,
      );
      return category ? category.id : 0;
    },
  },
};
</script>
